module.exports = __webpack_public_path__ + "media/icons/salonowy-grey@3x-93e86e82.svg";